import { useEffect, useRef } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { actualizarFlete } from '../../../service/AffariService';

const ResumenCotizacion = ({ resumen = {}, setResumen, idCotizacion, notify }) => {
    const lastFlete = useRef(resumen.flete ?? 0);

    useEffect(() => {
        lastFlete.current = resumen.flete ?? 0;
    }, [resumen.flete]);

    const handleFleteChange = async (value) => {
        const nextValue = value ?? 0;
        if (!idCotizacion) { if (notify) notify('warn', 'Cotización', 'ID de cotización no disponible'); return; }
        if (nextValue === lastFlete.current) return;
        try {
            await actualizarFlete(idCotizacion, nextValue);
            lastFlete.current = nextValue;
            if (notify) notify('success', 'Flete actualizado correctamente', 'valor');
        } catch (error) {
            if (notify) notify('error', 'Error actualizando flete', error.message || '');
        }
    };
    return (
        <div className="col-12 md:col-3">
            <div className="surface-0 p-3 text-sm">
                <div className="flex justify-content-between align-items-center mb-2">
                    <span className="text-500">Flete</span>
                    <InputNumber
                        value={resumen.flete ?? 0}
                        onValueChange={(e) => {
                            const nextValue = e.value ?? 0;
                            setResumen(prev => ({ ...prev, flete: nextValue }));
                            handleFleteChange(nextValue);
                        }}
                        className="w-8rem"
                        inputClassName="p-inputtext-sm text-right h-2rem"
                        mode="currency"
                        currency="CLP"
                        locale="es-CL"
                    />
                </div>
                <div className="flex justify-content-between mb-2">
                    <span className="text-500">Subtotal</span>
                    <span className="font-medium text-right">{resumen.subtotal ?? '$0'}</span>
                </div>
                <div className="flex justify-content-between mb-2">
                    <span className="text-500">Descuento</span>
                    <span className="font-medium text-right">{resumen.descuento ?? '$0'}</span>
                </div>
                <div className="flex justify-content-between mb-2">
                    <span className="text-500">Neto</span>
                    <span className="font-medium text-right">{resumen.neto ?? '$0'}</span>
                </div>
                <div className="flex justify-content-between mb-2">
                    <span className="text-500">IVA</span>
                    <span className="font-medium text-right">{resumen.iva ?? '$0'}</span>
                </div>
                <div className="flex justify-content-between font-bold text-lg mt-3 border-top-1 surface-border pt-2">
                    <span>Total</span>
                    <span>{resumen.total ?? '$0'}</span>
                </div>
            </div>
        </div>
    );
};

export default ResumenCotizacion;